import { Link, useParams } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";

const PAGES = {
  "confidentialite": {
    title: "Politique de confidentialité",
    updated: "30 mai 2026",
    body: [
      ["Engagement", "CAFÉ-SPOT respecte la Loi sur la protection des renseignements personnels dans le secteur privé (Loi 25, Québec). Vos données sont traitées avec le plus grand soin et ne sont jamais vendues à des tiers."],
      ["Données collectées", "Nous collectons : nom, courriel, téléphone, mot de passe chiffré (bcrypt), informations de votre commerce (adresse, photos, horaires), informations de paiement (gérées par Stripe — nous ne stockons aucune information de carte), données de navigation (vues, clics, IP anonymisée)."],
      ["Finalités", "Authentification, gestion d'abonnement, affichage public du commerce (avec consentement), statistiques agrégées, communications transactionnelles (vérification, factures, alertes paiement)."],
      ["Hébergement & sécurité", "Données hébergées au Canada / États-Unis chez nos fournisseurs cloud. Chiffrement TLS en transit. Mots de passe stockés avec bcrypt. Accès restreint au strict nécessaire."],
      ["Partenaires", "Stripe (paiements, conforme PCI-DSS), Resend (emails transactionnels), Emergent Object Storage (photos)."],
      ["Vos droits", "Accès, rectification, suppression, portabilité, retrait de consentement. Pour exercer : confidentialite@cafe-spot.ca."],
      ["Responsable des renseignements personnels", "Conformément à la Loi 25, le responsable peut être contacté par courriel à confidentialite@cafe-spot.ca."],
      ["Contact général", "Pour toute autre question : support@cafe-spot.ca."],
      ["Conservation", "Données de compte : durée de l'abonnement + 3 ans. Données de paiement : selon obligations fiscales (7 ans). Données anonymisées : indéfiniment pour statistiques."],
    ],
  },
  "conditions": {
    title: "Conditions d'utilisation",
    updated: "30 mai 2026",
    body: [
      ["Objet", "CAFÉ-SPOT est une plateforme de découverte et de réservation pour les cafés, boulangeries, pâtisseries et commerces similaires au Québec et au Canada. Aucune vente, livraison ou commande n'est gérée par la plateforme."],
      ["Acceptation", "L'utilisation du site implique l'acceptation des présentes conditions, de la politique de confidentialité et de la politique relative aux cookies."],
      ["Compte utilisateur", "Le compte est strictement personnel. Vous êtes responsable de la confidentialité de votre mot de passe et de toutes les activités effectuées depuis votre compte."],
      ["Contenu publié par les commerces", "Le commerce est seul responsable de l'exactitude, de la légalité et des droits sur les contenus publiés (textes, photos). Les informations trompeuses ou frauduleuses entraînent suppression sans préavis ni remboursement."],
      ["Disponibilité", "Nous nous efforçons d'offrir un service ininterrompu mais ne garantissons aucune disponibilité contractuelle."],
      ["Limitation de responsabilité", "CAFÉ-SPOT n'est pas partie aux transactions ou interactions entre visiteurs et commerces. Nous facilitons uniquement la mise en relation."],
      ["Modification", "Nous pouvons modifier ces conditions à tout moment. Les utilisateurs seront informés des changements substantiels par courriel."],
      ["Droit applicable", "Lois du Québec et du Canada. Juridiction des tribunaux du district de Montréal."],
    ],
  },
  "cookies": {
    title: "Politique relative aux cookies",
    updated: "30 mai 2026",
    body: [
      ["Qu'est-ce qu'un cookie ?", "Un cookie est un petit fichier déposé sur votre appareil pour mémoriser des informations de session ou de préférences."],
      ["Cookies essentiels", "Nécessaires au fonctionnement du site (authentification JWT en stockage local, préférence de langue). Aucun consentement requis."],
      ["Cookies analytiques", "Aucun cookie analytique tiers (Google Analytics, Facebook Pixel) n'est utilisé pour le moment. Statistiques internes uniquement, anonymisées."],
      ["Cookies marketing", "Aucun."],
      ["Gestion", "Vous pouvez bloquer les cookies via les paramètres de votre navigateur. Le blocage des cookies essentiels rendra l'authentification impossible."],
    ],
  },
  "abonnement": {
    title: "Conditions d'abonnement",
    updated: "30 mai 2026",
    body: [
      ["Plans", "Standard 39 $ CAD / mois — Premium 59 $ CAD / mois. Taxes (TPS 5 %, TVQ 9,975 %) en sus."],
      ["Paiement", "Récurrent mensuel via Stripe (carte de crédit). Aucun engagement à long terme : annulation possible à tout moment depuis le portail Stripe accessible dans votre tableau de bord."],
      ["Activation", "L'accès aux fonctionnalités payantes (publication publique, réservations en ligne, statistiques) est activé automatiquement à réception du paiement et confirmation par Stripe."],
      ["Période de grâce", "En cas d'échec de paiement, une période de grâce de 6 jours s'applique. Le commerce reste visible. Au-delà, suspension automatique. Réactivation automatique dès régularisation."],
      ["Remboursement", "Les paiements mensuels ne sont pas remboursables au prorata. L'abonnement reste actif jusqu'à la fin de la période payée en cours."],
      ["Modification du plan", "Possible à tout moment. La différence est calculée au prorata par Stripe sur le cycle suivant."],
      ["Annulation par CAFÉ-SPOT", "En cas d'informations trompeuses, frauduleuses ou de contenu illégal, l'abonnement peut être résilié sans préavis ni remboursement."],
      ["Facturation", "Une facture conforme TPS / TVQ est émise automatiquement après chaque paiement, téléchargeable en PDF depuis le tableau de bord."],
    ],
  },
  "reservation": {
    title: "Politique de réservation",
    updated: "30 mai 2026",
    body: [
      ["Rôle de CAFÉ-SPOT", "CAFÉ-SPOT transmet les demandes de réservation au commerce concerné. Le commerce est seul responsable d'accepter, confirmer ou refuser la demande."],
      ["Engagement du visiteur", "Toute demande envoyée implique l'engagement du visiteur à se présenter à l'heure indiquée. Les no-shows répétés peuvent entraîner un signalement au commerce."],
      ["Annulation", "Pour annuler, contactez directement le commerce par téléphone."],
      ["Données partagées avec le commerce", "Nom, téléphone, courriel (optionnel), nombre de personnes, date, heure, notes. Aucune donnée bancaire."],
      ["Réservations optionnelles", "Tous les commerces n'acceptent pas les réservations en ligne. L'option est activable par le commerce dans son tableau de bord."],
    ],
  },
  "facturation": {
    title: "Politique de facturation",
    updated: "30 mai 2026",
    body: [
      ["Émetteur", "La plateforme CAFÉ-SPOT (cafe-spot.ca), basée au Québec, Canada. L'entreprise n'est pas actuellement constituée en société par actions."],
      ["Taxes", "TPS (Taxe sur les produits et services) 5 % — TVQ (Taxe de vente du Québec) 9,975 %. Les taxes sont appliquées sur le prix de base de l'abonnement."],
      ["Format", "Factures PDF, numérotées séquentiellement (CS-AAAA-NNNNN), incluant : numéro de facture, date, identité du client (nom du commerce), description, sous-total, TPS, TVQ, total, statut de paiement."],
      ["Envoi", "Facture générée automatiquement à chaque paiement réussi et disponible immédiatement dans le tableau de bord."],
      ["Conservation", "Les factures sont conservées pendant 7 ans conformément aux exigences fiscales canadiennes."],
      ["Questions", "facturation@cafe-spot.ca"],
    ],
  },
};

const TABS = [
  ["confidentialite", "Confidentialité"],
  ["conditions", "Conditions d'utilisation"],
  ["cookies", "Cookies"],
  ["abonnement", "Abonnement"],
  ["reservation", "Réservation"],
  ["facturation", "Facturation"],
];

export default function Legal() {
  const { page = "confidentialite" } = useParams();
  const content = PAGES[page] || PAGES.confidentialite;
  return (
    <div data-testid="legal-page" className="min-h-screen text-[#F5F0EB]">
      <Header />
      <section className="pt-32 pb-16 px-6 md:px-12">
        <div className="max-w-[1100px] mx-auto">
          <div className="overline mb-3">Mentions légales · Québec</div>
          <h1 className="font-serif text-4xl md:text-6xl font-light mb-2">{content.title}</h1>
          <div className="text-xs text-[#A8A39D] tracking-widest uppercase">Mis à jour : {content.updated}</div>

          <div className="mt-10 flex flex-wrap gap-2 border-b border-white/5 pb-6">
            {TABS.map(([slug, label]) => (
              <Link key={slug} to={`/legal/${slug}`} data-testid={`legal-${slug}`} className={`px-4 py-2 text-xs tracking-[0.15em] uppercase border ${page === slug ? "border-[#C5A059] text-[#C5A059]" : "border-white/10 text-[#A8A39D] hover:text-[#F5F0EB]"}`}>{label}</Link>
            ))}
          </div>

          <div className="mt-10 space-y-10">
            {content.body.map(([heading, text], i) => (
              <div key={i}>
                <div className="overline mb-3">{heading}</div>
                <p className="text-[#F5F0EB] text-sm leading-7 max-w-[70ch]">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
